module.exports = {
    id: 37,
    name: "up换机完成照",
    type: "changeComplete",
    form: [
        {
            label: "手机正面照片",
            prop: "tem_img",
            obj: "order",
            type: "img",
            watermark: true
        },
        {
            label: "工单",
            prop: "tem_work",
            obj: "order",
            type: "img",
            watermark: true
        },
        {
            label: "工单2",
            prop: "tem_work2",
            obj: "order",
            type: "img",
            watermark: true
        },
        {
            label: "工单3",
            prop: "tem_work3",
            obj: "order",
            type: "img",
            watermark: true
        },
        {
            label: "工单4",
            prop: "tem_work4",
            obj: "order",
            type: "img4",
            watermark: true,
            notSubmit: true, // 不参与总的提交
        },
        {
            label: "出险产品",
            prop: "instype_name",
            obj: "order",
            type: "input",
            append: "viewOrder"
        },
        {
            label: "换机类型",
            prop: "ins_service_name",
            obj: "order",
            type: "select",
            optListName: "iphoneServeList",
            optLabel: "ins_service_name",
            optValue: "ins_service_name"
        },
        {
            label: "新机价格",
            prop: "new_price",
            obj: "order",
            type: "input"
        },
        {
            label: "原机IMEI",
            prop: "old_imei",
            obj: "order",
            type: "input"
        },
        {
            label: "上传日期",
            prop: "add_time",
            obj: "order",
            type: "date"
        },
        {
            label: "新机品牌",
            prop: "brand_id",
            obj: "order",
            type: "select",
            optListName: "brandList",
            optLabel: "brand",
            optValue: "brand_id",
            relate: "model"
        },
        {
            label: "新机型号",
            prop: "model_id",
            obj: "order",
            type: "select",
            optListName: "modelList",
            optLabel: "model_name",
            optValue: "model_id"
        },
        {
            label: "新IMEI码",
            prop: "imei",
            obj: "order",
            type: "input",
            isNew: true,
        },
        {
            label: "新机内存",
            prop: "ram_size",
            obj: "order",
            type: "select",
            optListName: "RAMList"
        },
        {
            label: "补交金额",
            prop: "money",
            obj: "order",
            type: "input"
        },
        {
            label: "赔付金额",
            prop: "claims_money",
            obj: "order",
            type: "input"
        },
        {
            label: "销单号/订单号",
            prop: "odd_num",
            obj: "order",
            type: "input"
        },
        {
            label: "审核结果",
            prop: "exa_status",
            obj: "order",
            type: "radio",
            optListName: "statusList",
            optLabel: "name",
            optValue: "status"
        },
        {
            label: "回复内容",
            prop: "fail_exp",
            obj: "order",
            type: "textarea"
        }
    ],
    tableColumns: [
        {
            slotName: "headimg"
        },
        {
            label: "注册者昵称",
            prop: "nickname"
        },
        {
            slotName: "operation"
        }
    ],
    piccCallbackType: 2
}

